import './css/PagesTab.css';

import * as React from 'react';

import { IPage, ISpread } from '../../../../../infrastructure/interfaces';
import Logo from '../Logo';
import { ProductType } from 'src/infrastructure/ProductType';


export interface IPagesTabProps {
  pages: IPage[];
  spreads: ISpread[];
  selectedPage: IPage;
  selectedSpread: ISpread;
  selectPage(page: IPage): void;
  selectSpread(spread: ISpread): void;
  productType: ProductType;
}


export default class ProductTab extends React.Component<IPagesTabProps> {

  onClick = (item: any) => {
      this.props.selectSpread(item);
  }

  renderSpreads = (spreads: ISpread[], selected: ISpread) => {
    return (
      spreads.map((s, i) => {
        return (
          <div
            className={`item ${s.left.title === selected.left.title ? 'selected' : ''}`}
            key={i}
            onClick={() => this.onClick(s)}
          >
            <span>{(s.right) ? (s.right.type === 2 ? s.right.position : s.right.title) : ""}</span>
            &nbsp;/&nbsp;
            <span>{s.left.type === 2 ? s.left.position : s.left.title}</span>
            {s.left.type === 2 ? ' Inside' : ''}
          </div>);
      })
    );
  }

  renderPostcardSpreads = (spreads: ISpread[], selected: ISpread) => {
    return (
      spreads.map((s, i) => {
        return (
          <div
            className={`item ${s.left.title === selected.left.title ? 'selected' : ''}`}
            key={i}
            onClick={() => this.onClick(s)}
          >
            <span>{(s.left) ? (s.left.type === 0 ? "Front" : "Back") : ""}</span>
          </div>);
      })
    );
  }

  render() {
    return (
      <div className={`sidePane`}>
        <div>
          {
            this.props.productType === 'Postcard'
            ? this.renderPostcardSpreads(this.props.spreads, this.props.selectedSpread)
            : this.renderSpreads(this.props.spreads, this.props.selectedSpread)
          }
        </div>
        <Logo />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Editor/components/SidePanel/PagesTab/PagesTab.tsx